<!--
@component
Site footer with logo, links and copyright.
-->
<script lang="ts">
  import GithubIcon from "$lib/assets/logos/socials/GithubLogo.svelte";
  import Linkedin from "$lib/assets/logos/socials/LinkedinLogo.svelte";
  import XLogo from "$lib/assets/logos/socials/XLogo.svelte";
  import logotypeDark from "$lib/assets/logotype-dark.svg";
  import logotype from "$lib/assets/logotype.svg";
  import CopyrightNotice from "$lib/design-systems/product/patterns/CopyrightNotice.svelte";
</script>

<!-- This margin element is separate from the element below, and it disables pointer interactions. -->
<div class="pointer-events-none mt-24"></div>

<!-- 72rem fits the logotype, copyright, links, and social icons on one line. -->
<footer class="@container mt-auto">
  <div
    class="flex flex-col gap-y-[27px] border-t border-secondary px-4 py-6 @min-[72rem]:flex-row @min-[72rem]:items-center"
  >
    <div class="flex min-h-5 items-center gap-x-3">
      <img
        src={logotype}
        alt="Modal logo"
        class="logotype logotype-default h-[18px]"
      />
      <img
        src={logotypeDark}
        alt="Modal logo"
        class="logotype logotype-light h-[18px]"
      />
      <span class="text-xs whitespace-nowrap text-tertiary"
        ><CopyrightNotice /></span
      >
    </div>
    <div
      class="grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-4 @min-[72rem]:mr-14 @min-[72rem]:ml-auto @min-[72rem]:flex"
    >
      <a class="link" href="/company">About</a>
      <a
        class="link"
        href="https://status.modal.com/"
        target="_blank"
        rel="noopener noreferrer">Status</a
      >
      <a class="link" href="/changelog">Changelog</a>
      <a class="link" href="/docs/sdk/py/releases">Releases</a>
      <a class="link" href="/docs/guide">Documentation</a>
      <a class="link" href="/slack" target="_blank" rel="noopener noreferrer"
        >Slack Community</a
      >
      <a class="link" href="/pricing">Pricing</a>
      <a class="link" href="/docs/examples">Examples</a>
    </div>
    <div class="flex space-x-4">
      <a
        href="https://www.linkedin.com/company/modal-labs/"
        target="_blank"
        rel="noreferrer"
        class="social-link"
      >
        <Linkedin size={20} class="fill-current stroke-none" />
      </a>
      <a
        href="https://x.com/modal"
        target="_blank"
        rel="noreferrer"
        class="social-link"
      >
        <XLogo size={20} class="fill-current stroke-none" />
      </a>
      <a
        href="https://github.com/modal-labs"
        target="_blank"
        rel="noreferrer"
        class="social-link"
      >
        <GithubIcon size={20} class="fill-current stroke-none" />
      </a>
    </div>
  </div>
</footer>

<style lang="postcss">
  @reference "$app.css";

  .link {
    @apply text-sm text-secondary transition-colors hover:text-secondary-hover;
  }

  .social-link {
    @apply icon-secondary transition-colors hover:icon-secondary-hover;
  }

  .logotype-light {
    display: none;
  }

  :global([data-theme="light"]) .logotype-default {
    display: none;
  }

  :global([data-theme="light"]) .logotype-light {
    display: block;
  }
</style>
